export default "__VITE_ASSET__BNvqQbYr__"